var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculadora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.033,
    height: 32.044,
    viewBox: "0 0 24.033 32.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7159",
    "data-name": "Grupo 7159",
    transform: "translate(-45.725 -14.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7158",
    "data-name": "Grupo 7158",
    transform: "translate(45.725 14.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculator"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2464",
    "data-name": "Trazado 2464",
    d: "M22.027,2a2,2,0,0,1,2,2V28.038a2,2,0,0,1-2,2H6.005a2,2,0,0,1-2-2V4.005a2,2,0,0,1,2-2ZM6.005,0A4.005,4.005,0,0,0,2,4.005V28.038a4.005,4.005,0,0,0,4.005,4.005H22.027a4.005,4.005,0,0,0,4.005-4.005V4.005A4.005,4.005,0,0,0,22.027,0Z",
    transform: "translate(-2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2465",
    "data-name": "Trazado 2465",
    d: "M4,2.981A.976.976,0,0,1,4.971,2H18.562a.976.976,0,0,1,.971.981V6.9a.976.976,0,0,1-.971.981H4.971A.976.976,0,0,1,4,6.9Zm0,7.848a.976.976,0,0,1,.971-.981H6.912a.976.976,0,0,1,.971.981v1.962a.976.976,0,0,1-.971.981H4.971A.976.976,0,0,1,4,12.791Zm0,5.886a.976.976,0,0,1,.971-.981H6.912a.976.976,0,0,1,.971.981v1.962a.976.976,0,0,1-.971.981H4.971A.976.976,0,0,1,4,18.677ZM4,22.6a.976.976,0,0,1,.971-.981H6.912a.976.976,0,0,1,.971.981v1.962a.976.976,0,0,1-.971.981H4.971A.976.976,0,0,1,4,24.563ZM9.825,10.829a.976.976,0,0,1,.971-.981h1.942a.976.976,0,0,1,.971.981v1.962a.976.976,0,0,1-.971.981H10.8a.976.976,0,0,1-.971-.981Zm0,5.886a.976.976,0,0,1,.971-.981h1.942a.976.976,0,0,1,.971.981v1.962a.976.976,0,0,1-.971.981H10.8a.976.976,0,0,1-.971-.981Zm0,5.886a.976.976,0,0,1,.971-.981h1.942a.976.976,0,0,1,.971.981v1.962a.976.976,0,0,1-.971.981H10.8a.976.976,0,0,1-.971-.981ZM15.65,10.829a.976.976,0,0,1,.971-.981h1.942a.976.976,0,0,1,.971.981v1.962a.976.976,0,0,1-.971.981H16.62a.976.976,0,0,1-.971-.981Zm0,5.886a.976.976,0,0,1,.971-.981h1.942a.976.976,0,0,1,.971.981v7.848a.976.976,0,0,1-.971.981H16.62a.976.976,0,0,1-.971-.981Z",
    transform: "translate(0.25 2.25)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculadora);
export default __webpack_public_path__ + "static/media/calculadora.f02282748b5fe1b4f1e47758e1f2427a.svg";
export { ForwardRef as ReactComponent };